import { type SWRMutationResponse } from 'swr/mutation'

import { SellerCentralControllerV1ApiFactory } from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'
import { useMarketplacePartnerRegisterPageContext } from '../../components/marketplacePartnerRegisterPageContext'

import { marketplacePartnerRegisterPageBuildRequestBodyFromLegacyModelV1 } from './marketplacePartnerRegisterPageBuildRequestBodyFromModel'
import { useMarketplacePartnerRegisterPageFormApiPostMutation } from './useMarketplacePartnerRegisterPageFormApiPostMutation'

export const useMarketplacePartnerRegisterPageFormApiPostMutationV1 =
  (): SWRMutationResponse<void> => {
    const client = useGlooApi(SellerCentralControllerV1ApiFactory)
    const { formState } = useMarketplacePartnerRegisterPageContext()
    const config = useGlobalConfigContext()

    const fetcher = async (): Promise<void> => {
      const requestBody =
        marketplacePartnerRegisterPageBuildRequestBodyFromLegacyModelV1({
          ...formState.model,
        })

      const payload = {
        Accept_Language: config.locale,
        language: config.language,
        SellerRegisterRequestV1: requestBody,
        tenant: config.tenantAndEnv,
      }
      await client.sellerCentralV1LanguageTenantSellerRegisterPost(payload)
    }

    return useMarketplacePartnerRegisterPageFormApiPostMutation(fetcher)
  }
